<template>
  <v-app light>
    <router-view />
    <BlockUI
      style="color: #1976D2; font-size: 18px;"
      :message="$root.blockUImsg"
      v-if="$root.blockUIshow"
    >
      <v-progress-circular :size="60" :width="4" color="primary" indeterminate></v-progress-circular>
    </BlockUI>
  </v-app>
</template>

<script>
import constant from "./const"
import firebase from "firebase/app"
import "firebase/auth"

export default {
  name: "App",
  components: {},
  data() {
    return {}
  },
  created() {
    var self = this
    // check the state of current user
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        console.log("User is SIGNED-IN")
      } else {
        // No user is signed in.
        console.log(
          "User is either not signed in or authentication is not valid"
        )
        if (constant.IGNORE_PATHS.includes(self.$route.name)) {
          // ignore
          console.log("ignore because this is: ", self.$route.name)
        } else if (
          self.$route.name != "login" &&
          self.$route.name != "register"
        ) {
          self.$root.logout()
        }
      }
    })
  },
  mounted() {}
}
</script>

<style>
</style>

